// @flow @format
import FilesLayout from './FilesLayout';
export default FilesLayout;



// WEBPACK FOOTER //
// ./src/routes/Explorer/layouts/FilesLayout/index.js